module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18Pl1x6/tc-custom/9781591811381.jpg?1718183146147",
      "alt": "This image is the cover for the book Nothing I See Means Anything"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nothing I See Means Anything\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Freudian psychoanalyst draws on mysticism, philosophy, and quantum physics to shed light on the power and potential of consciousness.")]), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("Nothing I See Means Anything")]), _vm._v(", Dr. David Parrish takes readers on an enlightening journey of the mind. Bringing clarity to a diverse range of complex concepts, he reveals fascinating insights into the nature of consciousness. Closing the gap between mind, matter, and cosmic intelligence, Parrish elegantly identifies the pathways to highest consciousness—a place we all are but don’t know it.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Parrish\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Sentient Publications\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0